import styles from "./Home.module.css";
// // import Avatar from "./components/Avatar/Avatar";
// import Avatar from "avataaars";

import { Link } from "react-scroll";

import Button from "../../components/Button/Button";

import Typed from "react-typed";
import 'react-typed/dist/animatedCursor.css';

const Home = () => {
  return (
    <section className={styles.Home} name="Home" id="main-content">
      <div className={styles.content}>
        <h1 className={styles.title}>
          Hi! I Am <span>Shivansh Soni</span>
        </h1>
        <h3 className={styles.subTitle}>
          I am into{" "}
          <Typed
            strings={["Full Stack Development", "Problem Solving", "Competitive Programming" ,"Engineering"]}
            typeSpeed={200}
            backSpeed={50}
            loop
          />
        </h3>

        <div className={styles.btnContainer}>
          <Button isLink={true}>
            <Link
              href="#Projects"
              to="Projects"
              spy={true}
              smooth={true}
              duration={500}
              offset={0}
            >
              Explore
            </Link>
          </Button>
          <Button link={"mailto:2021002287.shivansh@ug.sharda.ac.in"}>Email</Button>
        </div>
      </div>

      {/* <Avatar 
      // style={{width: '450px', height: '450px'}}
  avatarStyle='Circle'
  topType='ShortHairShortCurly'
  accessoriesType='Blank'
  hairColor='Black'
  facialHairType='BeardLight'
  facialHairColor='Black'
  clotheType='Hoodie'
  clotheColor='Heather'
  eyeType='Happy'
  eyebrowType='DefaultNatural'
  mouthType='Twinkle'
  skinColor='Light'
  
/> */}
<img className={styles.image} src='https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortCurly&accessoriesType=Blank&hairColor=Black&facialHairType=BeardLight&facialHairColor=Black&clotheType=Hoodie&clotheColor=Heather&eyeType=Happy&eyebrowType=Default&mouthType=Twinkle&skinColor=Light'
   alt="Avatar" />
    </section>
  );
};

export { Home };
